import { render, staticRenderFns } from "./AssessmentRegimes.vue?vue&type=template&id=159bfbe3&"
import script from "./AssessmentRegimes.vue?vue&type=script&lang=js&"
export * from "./AssessmentRegimes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports